<template>
    <div class="d-flex pb-4">
        <div class="card card-scroll box-shadow">
            <div class="grid-thumb position-relative">
                <img
                    class="article-label lazyload img-fluid"
                    v-if="article.label_type != undefined"
                    :src="article.feature_label_img"
                    :alt="article.label_type"
                />

                <img
                    :src="article.img_main"
                    :alt="article.title"
                    class="grid-thumb img-fluid lazyload"
                    width="256"
                    height="135"
                />
                <div v-if="article.image_credits != null" class="image-credits">
                    &copy; {{ article.image_credits }}
                </div>
            </div>
            <div class="card-body d-flex flex-column">
                <div
                    class="
                        article-info
                        pb-3 pb-lg-3 pb-md-2
                        d-flex
                        align-items-center
                        justify-content-between 
                    "
                >
                    <div class="article-author d-flex align-items-center">
                        <div class="author-img">
                            <img
                                :src="article.author_image"
                                :alt="article.author_name"
                                class="lazyload"
                                width="30"
                                height="30"
                            />
                        </div>
                        <div class="author-name pl-2">
                            <a
                                v-if="article.author_profile_link != null"
                                :href="article.author_profile_link"
                                >{{ article.author_name }}</a
                            >
                            <span v-else>{{ article.author_name }}</span>
                        </div>
                    </div>
                    <div class="article-reading-time">
                    <!-- <div class="article-reading-time pl-md-4 pr-2 pr-md-0"> -->
                        {{ article.reading_time }}
                    </div>
                </div>
                <div class="article-title pb-2 pb-lg-2 pb-md-1">
                    <a :href="article.path" class="stretched-link">{{ article.title }}</a>
                </div>
                <div class="article-short-description">
                    {{ article.short_description }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        article: Object,
    },
};
</script>